function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M73.333 40c0 18.413-14.923 33.333-33.333 33.333-18.41 0-33.334-14.92-33.334-33.334C6.666 21.593 21.59 6.666 40 6.666c18.41 0 33.333 14.927 33.333 33.333z",
  fill: "#555"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.9 42.102a2.922 2.922 0 01-2.917 2.917 2.922 2.922 0 01-2.916-2.917V27.37a2.922 2.922 0 012.916-2.917A2.922 2.922 0 0142.9 27.37v14.733zm-5.817 10.576c0-1.606 1.304-2.916 2.9-2.916 1.644 0 2.95 1.31 2.95 2.916a2.92 2.92 0 01-2.916 2.917c-1.617 0-2.934-1.31-2.934-2.917z",
  fill: "#555"
});
function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgNoResults;